import { Theme, ThemeFactory } from "react-ui";
import { KonturColors } from "@skbkontur/colors";

import { reactUIDefaultTheme } from "./ReactUIDefaultTheme";

export const reactUILogisticsTheme: Theme = ThemeFactory.create(
    {
        linkActiveColor: KonturColors.greenMint70,
        linkColor: KonturColors.greenMint90,
        btnLinkColor: KonturColors.greenMint90,
        linkDisabledColor: KonturColors.grayscaleDisabledText,
        btnLinkDisabledColor: KonturColors.grayscaleSecondaryText,
        linkHoverColor: "#7d7d7d",
        btnLinkHoverColor: KonturColors.greenMint70,
        linkHoverTextDecoration: "none",
    },
    reactUIDefaultTheme
);
